import * as types from '../action_types';

export const languageActiveChange = (data) => {
  return {
    type: types.LANGUAGE_DATA_CHANGE_ACTIVE,
    payload: data,
  };
};
